<template>
  <div v-if="detailDevisCommande"
       class="is-flex pdt-20px columns">
    <div class="column is-10 corps">
      <qd-loader :active="isLoading"
                 class="has-background-background is-paddingless">
        <stepper  :steps="tabFilArianeDcf"
                  :last-active-step="getLastActiveStep"
                  :actual-step="0">
        </stepper>
      </qd-loader>
       <qd-message
          v-if="!isSyncRegleWithLignes && modulePresseActive"
          type="is-warning"
          aria-close-label="Close message">
          {{ $t('editionCommande.informations.regleFacturation.erreur') }}
      </qd-message>
      <user-warning-message
        :users="[
          { id: devisCommande.commercialId, msg: 'utilisateur.warning.commercialArchive' },
          { id: devisCommande.assistantId, msg: 'utilisateur.warning.assistantArchive' },
        ]"/>
      <contact-warning-message :contacts="archivedContacts"/>
      <informations-generales :info="detailDevisCommande.generalInfos"
                              :devisCommande="devisCommande"
                              :type="devisCommande.type"/>
      <br>
      <client-payeur
        :payeurs="detailDevisCommande.payeurs"
        :intervenantsNonPayeurs="detailDevisCommande.intervenants"
        :afficherLienDetail="activeButtonEtLien"/>
      <br>
      <div class="card"
           id="detail-command">
        <div class="card-content details">
          <div class="is-pulled-left">
            <logo-agence
                v-if="(logoParAgence || devisCommande.regleFacturationId) && logo"
                :logo="logo"></logo-agence>
            <logo-societe v-else :societeId="devisCommande.societeId"></logo-societe>
          </div>
          <div class="reference">
            <div>
              <strong>{{ detailDevisCommande.code }}</strong>
            </div>
            <span>{{ detailDevisCommande.generalInfos.dateDevisCommande }}</span>
          </div>
          <div class="intervenant is-flex" :class="{'is-spaced-between': commercial}">
            <infos-commercial v-if="commercial"
                              :commercial="commercial"
                              :reference-client="detailDevisCommande.referenceClient"
                              :code-dossier="detailDevisCommande.codeDossier"/>
            <div class="has-text-right"
                 :class="{'pull-right': !commercial}">
              <div v-if="mentionMandataire" class="has-text-weight-bold">
                {{ payeurSelected.titre ? payeurSelected.titre : payeurSelected.libelle }}
              </div>
              <div>
                <router-link-blank v-if="activeButtonEtLien"
                  :to="{ name: 'c.bodac.clients/contacts-client',
                    params: {id: payeurSelected.tiersId}}"
                  :message="intituleAdressePayeur"/>
                  <span v-else>{{ intituleAdressePayeur }}</span>
              </div>
              <div>
                {{ payeurSelected.adressePostale.intitule2 }}
                <span v-if="mentionMandataire">
                {{ payeurSelected.adressePostale.intitule3 }}
              </span>
              </div>
              <div v-if="!mentionMandataire">
                {{ payeurSelected.adressePostale.intitule3 }}
              </div>
              <div>
                {{ payeurSelected.adressePostale.adresse1 }}
              </div>
              <div>
                {{ payeurSelected.adressePostale.codePostal }}
                <span v-if="payeurSelected.adressePostale.codePostal
              && payeurSelected.adressePostale.ville">
                -
              </span>
                {{ payeurSelected.adressePostale.ville }}
              </div>
              <div> {{ payeurSelected.adressePostale.pays }}</div>
            </div>
          </div>
          <infos-intervenant :intervenants="payeurSelected.annonceurs"
            :afficherLien="activeButtonEtLien"/>
          <infos-intervenant :intervenants="payeurSelected.donneursOrdre"
            :afficherLien="activeButtonEtLien"/>
          <infos-intervenant :intervenants="payeurSelected.intervenants"
            :afficherLien="activeButtonEtLien"/>
          <br>
          <small v-if="detailDevisCommande.reference">
            {{ $t('detail.commande.referenceDevis', {
            number: detailDevisCommande.reference.code,
            date: detailDevisCommande.reference.dateDevisCommande
            }) }}
          </small>
          <detail-lignes-commande
            :etat-dcf="devisCommande.etat"
            :masqueRemise="devisCommande.masqueRemise"
            :isPrevisualisation="false"
            :isEditPrevisu="false"
            :typeDCF="devisCommande.type"
            :afficherLien="activeButtonEtLien"
            :lignes-commande="detailDevisCommande.lignesCommande"/>
          <div class="summary-container">
            <div class="column is-4 is-paddingless">
              <repartitions-tva
                :repartitions-tva="detailDevisCommande.repartitionsTva"
                v-if="devisCommande.montantTva !== 0"/>
              <br>
              <acomptes-affectes
                :payeurSelected='payeurSelected'
                :facturesAcompte="detailDevisCommande.acomptesAffectes"
                v-if="detailDevisCommande.acomptesAffectes.length > 0">
              </acomptes-affectes>
              <template v-if="detailDevisCommande.tauxPenalite">
                <small>
                  {{ $t('detail.conditions.tauxPenalite') }}
                  &nbsp;{{ detailDevisCommande.tauxPenalite }} %
                </small>
                <br><br>
              </template>
              <template v-if="detailDevisCommande.penalite">
                <div v-if="devisCommande.textPenalite.length > 0"
                  v-html="devisCommande.textPenalite"></div>
                <small v-else>{{ $t('detail.conditions.penalite') }}</small>
                <br><br>
              </template>
              <template v-if="devisCommande.recouvrement">
                <small>
                  <div>{{ $t('detail.conditions.recouvrement') }}</div>
                </small>
                <br>
              </template>
              <template v-if="detailDevisCommande.tauxEscompte">
                <small>{{ $t('detail.conditions.tauxEscompte') }}
                  &nbsp;{{ detailDevisCommande.tauxEscompte }} %</small>
                <br><br>
              </template>
              <template v-if="detailDevisCommande.escompte">
                <small>{{ $t('detail.conditions.escompte') }}</small>
                <br><br>
              </template>
              <div v-if="detailDevisCommande.commentaire">
                  <span class="has-text-weight-bold">
                    {{ $t('detail.conditions.commentaires') }}
                  </span>
                <br>
                <small>{{ detailDevisCommande.commentaire }}</small>
              </div>
              <div v-if="detailDevisCommande.adresseLivraison" class="mgt-10px">
                    <span class="has-text-weight-bold">
                      {{ $t('detail.conditions.adresseLivraison') }}
                    </span>
                <br>
                <small class="is-prewrap">{{ detailDevisCommande.adresseLivraison }}</small>
              </div>
            </div>
            <div class="column is-4 is-paddingless">
              <recapitulatif-montants :recapitulatif="detailDevisCommande.recapitulatifMontants"/>
              <br>
              <repartition-recapitulatif-montants
                :acomptes='detailDevisCommande.acomptesAffectes'
                :recapitulatif="detailDevisCommande.recapitulatifMontants"
                :payeur="payeurSelected"/>
            </div>
          </div>
        </div>
      </div>
      <template v-if="detailDevisCommande.commentaireInterne">
        <br>
        <div class="card"
             id="detail-comments">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.comments')}}
            </p>
          </header>
          <div class="card-content">
            <template>
              <div class="mgb-10px">
                <strong>{{ $t('editionCommande.informations.internCommentary') }}</strong>
              </div>
              <span>{{ detailDevisCommande.commentaireInterne }}</span>
            </template>
          </div>
        </div>
      </template>
      <div class="card mgt-20px" id="attachments">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions=checkPermissions(permDevis.maj)
                              :can-add-pj="devisCommande.etat !== constantes.ETAT_BROUILLON"
                              :canAddOrDeletePj="activeButtonEtLien"
                              readOnly
                              deletable
                              autoSave />
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="sticky-20px">
        <dots-menu :steps="steps" class="mgt-20px">
        </dots-menu>
        <information-create-update-user :data="devisCommande"></information-create-update-user>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import PiecesJointes from '@/components/general/piecesJointes';
import * as devisConf from '@/configuration/devisConf';
import DotsMenu from '@/components/general/dotsMenu';
import acomptesAffectes from '@/components/devisCommandes/detailDevisCommande/acomptesAffectes';
import { DEVIS, TIERS } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import logoSociete from '@/components/general/logoSociete';
import logoAgence from '@/components/general/logoAgence';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import stepper from '@/components/devisCommandeFacture/detail/stepper/stepper';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import contactWarningMessage from '@/components/commun/tiers/contact/contactWarningMessage';
import createFilArianeDevis from '@/services/dcf/detail/filAriane/createFilArianeDevis';
import messageErreur from '@/services/general/messageErreur';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import { PIECE_JOINTE_TYPE_LOGO_FACTURE } from '@/configuration/general/pieceJointeConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { REGIE } from '@/configuration/societe/societe';
import MixinParametreInterne from '@/mixins/parametreInterne';
import getArchivedContactsFromIntervenants from '@/services/contact/getArchivedContactsFromIntervenants';
import InformationsGenerales from './informationsGenerales';
import ClientPayeur from './clientPayeur';
import InfosIntervenant from './infosIntervenant';
import DetailLignesCommande from './detailLignesCommande';
import RepartitionsTva from './repartitionsTva';
import RecapitulatifMontants from './recapitulatifMontants';
import RepartitionRecapitulatifMontants from './repartitionRecapitulatifMontants';
import InfosCommercial from './infosCommercial';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'detail-devis',
  props: {
    devisCommande: {
      type: Object,
      required: true,
    },
    detailDevisCommande: {
      type: Object,
      required: true,
    },
    payeurSelected: {
      type: Object,
      required: true,
    },
    toolTipSignatureInfo: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  mixins: [MixinParametreInterne],
  components: {
    InformationCreateUpdateUser,
    logoSociete,
    InfosCommercial,
    acomptesAffectes,
    RepartitionRecapitulatifMontants,
    RecapitulatifMontants,
    RepartitionsTva,
    DetailLignesCommande,
    InformationsGenerales,
    DotsMenu,
    ClientPayeur,
    InfosIntervenant,
    appPiecesJointes: PiecesJointes,
    routerLinkBlank,
    stepper,
    logoAgence,
    userWarningMessage,
    contactWarningMessage,
  },
  data() {
    return {
      permDevis: DEVIS,
      tiers: TIERS,
      steps: [
        {
          name: this.$i18n.t('detail.generalInfos.title'),
          ref: '#detail-general',
          active: true,
        },
        {
          name: this.$i18n.t('detail.client.label'),
          ref: '#detail-client',
          active: false,
        },
        {
          name: this.$i18n.t('detail.devis.title'),
          ref: '#detail-command',
          active: false,
        },
        {
          name: this.$i18n.t('editionClient.generalTitle.comments'),
          ref: '#detail-comments',
          active: false,
        },
        {
          name: this.$i18n.t('detailDevis.steps.echeancierFacturation'),
          ref: '#detail-schedule',
          active: false,
        },
        {
          name: this.$i18n.t('piecesJointes.attachments'),
          ref: '#attachments',
          active: false,
        },
      ],
      tabFilArianeDcf: [],
      isLoading: false,
      constantes: {
        REGIE,
        ETAT_BROUILLON: devisConf.ETAT_BROUILLON,
      },
      logo: null,
      archivedContacts: [],
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      logoAgences: 'logoAgences',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    mentionMandataire() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.mentionMandataire.key)
      && this.payeurSelected.mandataire);
    },
    isSyncRegleWithLignes() {
      if (this.devisCommande.regleFacturationId) {
        return this.devisCommande.lignesCommande.length > 0
          && this.devisCommande.lignesCommande.some(ligne => {
            return ligne.produit
              && (ligne.produit.regleFacturationId === this.devisCommande.regleFacturationId);
          });
      }
      return true;
    },
    logoParAgence() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.logoParAgence.key)
        && this.devisCommande.sens === devisConf.SENS_VENTE);
    },
    getLastActiveStep() {
      const indexFirstStepNotActive = this.tabFilArianeDcf.findIndex((filAriane) => {
        return !filAriane.isActive;
      });
      return indexFirstStepNotActive - 1;
    },
    commercial() {
      if (this.detailDevisCommande.generalInfos && this.detailDevisCommande.generalInfos.commercial
          && this.detailDevisCommande.generalInfos.commercial.nom) {
        return this.detailDevisCommande.generalInfos.commercial;
      }
      return null;
    },
    getCommandsSteps() {
      if (!this.detailDevisCommande) return [];
      const steps = [devisConf.ETAT_ENREGISTRE];
      if (this.detailDevisCommande.etat === devisConf.ETAT_SANSSUITE) {
        steps.push(devisConf.ETAT_SANSSUITE);
      } else {
        steps.push(devisConf.ETAT_COMMANDE);
        steps.push(devisConf.ETAT_FACTURE);
      }
      return steps;
    },
    intituleAdressePayeur() {
      if (this.payeurSelected.adressePostale && this.payeurSelected.adressePostale.intitule1) {
        return this.payeurSelected.adressePostale.intitule1;
      }
      return this.payeurSelected.nomCommercial;
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.devisCommande.societeId);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    this.isLoading = true;
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.mentionMandataire.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.logoParAgence.key,
      ]);
      if (this.devisCommande.agenceId) {
        const logoAgence = this.logoAgences.find(logo => {
          return logo.elementId === this.devisCommande.agenceId;
        });
        this.logo = logoAgence ? (logoAgence.cheminMin || logoAgence.chemin) : null;
      }
      if (this.devisCommande?.regleFacturationId) {
        const logoDevisCommande = (await pGetAllPieceJointe({
          elementsId: [this.devisCommande.regleFacturationId],
        })).data.result.items.find(p => p.type.libelle === PIECE_JOINTE_TYPE_LOGO_FACTURE);
        this.logo = logoDevisCommande ? (logoDevisCommande.cheminMin || logoDevisCommande.chemin)
          : null;
      }
      createFilArianeDevis(this.devisCommande, this.societeActiveId,
        this.toolTipSignatureInfo).then(rsltTabAriane => {
        this.tabFilArianeDcf = rsltTabAriane;
        this.isLoading = false;
      }).catch(e => {
        this.isLoading = false;
        throw e;
      });
    } catch (e) {
      this.isLoading = false;
      messageErreur(this.$i18n);
      throw e;
    }
    this.archivedContacts = getArchivedContactsFromIntervenants(this.detailDevisCommande.payeurs);
  },
};
</script>
